export type MaximizedStepPane = "browser" | "execution";

export function maximizedStepPane(
  browserApplicable: boolean,
  urlExecutionId: string | undefined
): MaximizedStepPane {
  if (!browserApplicable) return "execution";
  if (urlExecutionId) return "execution";
  return "browser";
}
